module.exports = __webpack_public_path__ + "img/notificationSettings.d609e3d0.svg";